import {useAppContext} from "../../../../contexts/AppContext";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import baseUrl from "../../../../baseUrl";
import {CheckAvailability1, CheckAvailability2} from "./CheckAvailability/CheckAvailability";
import {requester} from "../../../../services/requester";
import {buildSettlementOptions} from "../../../../utils/settlements";
import {useCloseForm} from "../useCloseForm";

export const DealNew = ({onDealSubmit}) => {
    const {year, settlement_ekatte, bullstat} = useParams();
    const {companies} = useAppContext();
    // ЧАСТ К: тук НЕ се ползва списъкът от AppContext (той е ограничен по права
    // и пълни меню „Землища"). Замяната може да сочи към всяко активно землище —
    // землищата се разпределят между няколко души и замените редовно пресичат
    // тези граници. Пазачът е одобрението в насрещното землище.
    const [settlements, setSettlements] = useState([]);
    const [valueSettlementState, setValueSettlementState] = useState('');
    const [valueCompanyGivingState, setValueCompanyGivingState] = useState('');
    const [valueCompanyTakingState, setValueCompanyTakingState] = useState('');
    const [amount, setAmount] = useState(0);
    const [availabilityAmountGiving, setAvailabilityAmountGiving] = useState(0);
    const [availabilityAmountTaking, setAvailabilityAmountTaking] = useState(0);
    const request = requester();
    const closeForm = useCloseForm();

    // Е14: неопределените землища най-отгоре в списъка.
    const settlements_options = buildSettlementOptions(settlements);

    useEffect(() => {
        window.scroll({
            top: document.body.offsetHeight,
            left: 0,
            behavior: 'smooth',
        });
    }, [])

    useEffect(() => {
        request.get(`${baseUrl()}/settlements-for-deals`)
            .then(setSettlements)
            .catch(() => setSettlements([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const companies_options = [];

    companies.forEach(company => {
        companies_options.push({
            id: company.id,
            value: `${company.company_name}, ${company.city}, ${company.accountable_person}, ${company.bullstat}`
        });
    })


    const onChangeValueSettlementState = (event) => {
        setValueSettlementState(event.target.value);
    }

    const onChangeCompanyGivingState = (event) => {
        setValueCompanyGivingState(event.target.value);
    }

    const onChangeCompanyTakingState = (event) => {
        setValueCompanyTakingState(event.target.value);
    }

    const onChangeAmount = (event) => {
        setAmount(event.target.value);
    }


    const onSubmit = async (e) => {
        e.preventDefault();

        const body = {
            bullstat_giving: Number(valueCompanyGivingState.split(',')[3].trim()),
            bullstat_receiving: Number(valueCompanyTakingState.split(',')[3].trim()),
            settlement_giving: settlement_ekatte,
            settlement_receiving: valueSettlementState.split(',')[3].trim(),
            amount: Number(amount),
            year: Number(year)
        };

        try {
            await request.post(`${baseUrl()}/deals`, body);
            setValueSettlementState('');
            setValueCompanyGivingState('');
            setValueCompanyTakingState('');
            setAmount(0);
            onDealSubmit();
            alert('Замяната е записана.');   // Е14: БГ съобщение (не API текста)
            closeForm();                     // Р2: обратно най-горе
        } catch (err) {
            alert(err.message || 'Възникна грешка при заявката.');
        }

    };

    let disabledButton = true;

    if (valueSettlementState && valueCompanyGivingState && valueCompanyTakingState && amount) {
        if (valueCompanyGivingState !== valueCompanyTakingState)
            if (Number(amount) >= 0.01)
                disabledButton = false;
    } else {
        disabledButton = true;
    }

    const availabilityAmountGivingSetter = (amount) => {
        setAvailabilityAmountGiving(amount);
    }

    const availabilityAmountTakingSetter = (amount) => {
        setAvailabilityAmountTaking(amount);
    }

    return (
        <form onSubmit={onSubmit}>
            <div className="row g-3 align-items-center mt-1">
                <div className="col-1">
                    <label htmlFor="companyGiving" className="col-form-label">Даващ</label>
                </div>
                <div className="col-11">
                    <input className="col-11" type="search" list="list-company-giving" autoComplete="on"
                           value={valueCompanyGivingState}
                           onChange={onChangeCompanyGivingState}/>
                    <datalist id="list-company-giving">
                        {companies_options.map(d => <option key={d.id} value={d.value}/>)}
                    </datalist>
                </div>
                {valueCompanyGivingState && (
                    <CheckAvailability1
                        company={valueCompanyGivingState}
                        settlement={settlement_ekatte}
                        year={year}
                        availabilityAmountGivingSetter={availabilityAmountGivingSetter}
                    />
                )}

                <hr className="col-6"/>
                <div className="row g-3 align-items-center">
                    <div className="col-1">
                        <label htmlFor="companyTaking" className="col-form-label">Взимащ</label>
                    </div>
                    <div className="col-11">
                        <input className="col-11" type="search" list="list-company-taking" autoComplete="on"
                               value={valueCompanyTakingState}
                               onChange={onChangeCompanyTakingState}/>
                        <datalist id="list-company-taking">
                            {companies_options.map(d => <option key={d.id} value={d.value}/>)}
                        </datalist>
                    </div>
                </div>

                <div className="row g-3 align-items-center">
                    <div className="col-1">
                        <label htmlFor="settlement" className="col-form-label">За село</label>
                    </div>
                    <div className="col-11">
                        <input className="col-11" type="search" list="settlement" autoComplete="on"
                               value={valueSettlementState}
                               onChange={onChangeValueSettlementState}/>
                        <datalist id="settlement">
                            {settlements_options.map(d => <option key={d.id} value={d.value}/>)}
                        </datalist>
                    </div>
                    {valueCompanyTakingState && valueSettlementState && (
                        <CheckAvailability2
                            company={valueCompanyTakingState}
                            settlement={valueSettlementState}
                            year={year}
                            availabilityAmountTakingSetter={availabilityAmountTakingSetter}
                        />
                    )}

                </div>
                <hr className="col-6"/>
                {(availabilityAmountGiving < Number(amount)) && (
                    <div style={{color: "var(--app-danger-fg)"}}>ВНИМАНИЕ: Сумата на ДЗ е по - голяма от наличното на
                        даващия {Number(availabilityAmountGiving).toFixed(2)}!</div>
                )}
                {(availabilityAmountTaking < Number(amount)) && (
                    <div style={{color: "var(--app-danger-fg)"}}>ВНИМАНИЕ: Сумата на ДЗ е по - голяма от наличното на
                        взимащия {Number(availabilityAmountTaking).toFixed(2)}!</div>
                )}
                <div className="row g-3 align-items-center">
                    <div className="col-1">
                        <label htmlFor="amount" className="col-form-label">Сума</label>
                    </div>
                    <div className="col-2">
                        <input className="col-11" type="number" step="0.01" min="0.01" placeholder="Въведи площ"
                               value={amount}
                               onChange={onChangeAmount} required/>
                    </div>
                </div>
            </div>

            <button type="submit" className="btn btn-primary mt-3" disabled={disabledButton}>Прибави</button>
            {disabledButton && (
                <div style={{color: "var(--app-danger-fg)"}}>Формата не е попълнена коректно. Проверете дали даващия и взимащия са един и
                    същ или сумата е нула.</div>
            )}
        </form>
    );
};